export const QUICK_SOINS = [
  { name: "Ventouses", slug: "ventouses" },
  { name: "Magnétisme", slug: "lahochi" },
  { name: "Médecine chinoise", slug: "chi-nei-tsang" },
  { name: "Sophrologie", slug: "sophrologie-breathwork" },
  { name: "Ostéopathie", slug: "osteotherapie" },
  { name: "Réflexologie", slug: "reflexologie-plantaire" },
];

export const SOINS = [
  {
    slug: "chi-nei-tsang",
    name: "Chi Nei Tsang",
    tag: "Médecine chinoise · massage du ventre",
    price: "70 €",
    duration: "1 h",
    image: "/images/chi-nei-tsang.jpg",
    intro: "Un massage profond qui prend soin de votre ventre — notre premier cerveau — et relance les cinq systèmes majeurs du corps, à Bayonne.",
    description: [
      "Chi Nei Tsang signifie littéralement « travailler l'énergie des organes internes ». Les systèmes vasculaire, lymphatique, nerveux, musculaire et énergétique sont relancés. Il va à la source des problèmes de santé, y compris les réponses psychosomatiques.",
      "Le ventre est notre disque dur, le berceau de nos émotions : il contient 95 % de nos neurones producteurs de sérotonine, ce neurotransmetteur qui participe à la gestion du stress, des angoisses et des émotions.",
      "Par des pressions douces et des mouvements circulaires sur l'abdomen, je détends les muscles, stimule la circulation sanguine et lymphatique et libère les tensions. La respiration accompagne chaque mouvement, et les émotions liées aux organes — la colère (foie), la tristesse (poumons), la peur (reins) — sont abordées en douceur.",
      "Massage viscéral préventif, le Chi Nei Tsang est idéal au changement de saisons, ou lorsque vous vous dites : « J'ai une boule au ventre, l'estomac noué… »",
    ],
    bienfaits: ["Amélioration de la digestion (ballonnements, constipation)", "Réduction du stress et de l'anxiété", "Équilibre énergétique et vitalité", "Renforcement du système immunitaire"],
  },
  {
    slug: "osteotherapie",
    name: "Ostéothérapie & Reboutement",
    tag: "Alignement & structure",
    price: "70 €",
    duration: "1 h",
    image: "/images/osteotherapie.jpg",
    intro: "Une thérapie manuelle douce pour redonner de la mobilité et rétablir l'harmonie dans le corps, à Bayonne.",
    description: [
      "L'ostéothérapie tissulaire réflexe (OTR) est une méthode douce et efficiente qui traite, par la main, les dysfonctions de la micro-mobilité des tissus du corps — celles qui entraînent des troubles fonctionnels perturbant l'état de santé.",
      "J'utilise différentes techniques comme Dorn, Knap et Niromaté : trois méthodes douces où vous êtes l'acteur de vos mouvements et de la gestion de votre douleur. Je traite les sciatiques, tendinites, entorses, névralgies, en travaillant sur les muscles et les nerfs.",
      "Je crois fermement que le corps a une capacité naturelle à se guérir — mon rôle est de l'accompagner dans ce processus. Cette technique peut également être reçue à distance.",
    ],
    bienfaits: ["Sciatiques, tendinites, entorses, névralgies", "Libération des tensions physiques", "Meilleure mobilité", "Méthodes douces Dorn, Knap et Niromaté"],
  },
  {
    slug: "reflexologie-plantaire",
    name: "Réflexologie plantaire",
    tag: "Zones réflexes & relâchement",
    price: "70 €",
    duration: "1 h",
    image: "/images/reflexologie.jpg",
    intro: "Le corps entier est dessiné sous nos pieds — stimuler les zones réflexes pour rétablir le flux énergétique, à Bayonne.",
    description: [
      "La réflexologie plantaire fait partie des médecines douces : elle a pour but de relâcher les tensions dans le corps et les organes. Par le massage des pieds et des mains, tous nos organes sont stimulés grâce aux zones réflexes.",
      "Elle s'adresse aux maux du quotidien : insomnies, fatigue, stress, anxiété, problèmes de digestion, maux de dos, tension artérielle — ou simplement pour prendre soin de vous et lâcher prise. Elle contribue aussi à réduire les effets secondaires des traitements lourds comme la chimiothérapie.",
    ],
    bienfaits: ["Stress, anxiété, insomnies, fatigue", "Systèmes digestif, ORL, urinaire, hormonal", "Maux de dos et tension artérielle", "Confort pendant les traitements (chimiothérapie)"],
  },
  {
    slug: "drainage-lymphatique",
    name: "Drainage lymphatique",
    tag: "Détox & circulation",
    price: "70 €",
    duration: "1 h",
    image: "/images/drainage.jpg",
    intro: "Un massage détox doux et lent pour améliorer la circulation lymphatique et renforcer les défenses immunitaires, à Bayonne.",
    description: [
      "La technique est douce et lente, avec toute la main, sur l'ensemble du corps, dans le sens de la circulation sanguine et lymphatique. Elle régénère l'organisme, accélère la cicatrisation, diminue les risques d'infection et améliore l'aspect peau d'orange.",
      "Le drainage diminue l'œdème post-cancer, soulage les varices et apporte de nets résultats chez les personnes atteintes de fibromyalgie, spondylarthrite ou polyarthrite. Il est souvent conseillé de commencer par plusieurs séances rapprochées, puis de passer à un entretien régulier.",
    ],
    bienfaits: ["Détoxification et défenses immunitaires", "Réduction des œdèmes et de la rétention d'eau", "Confort varices, fibromyalgie, polyarthrite", "Amélioration de la peau d'orange"],
  },
  {
    slug: "sophrologie-breathwork",
    name: "Sophrologie & Breathwork",
    tag: "Respiration & conscience",
    price: "70 €",
    duration: "1 h",
    image: "/images/breathwork.jpg",
    intro: "Deux méthodes puissantes pour reconnecter le corps et l'esprit par la respiration, à Bayonne.",
    description: [
      "La sophrologie, par ses techniques de relaxation et de visualisation, aide à gérer le stress et à cultiver une attitude positive. Le breathwork utilise la respiration consciente pour libérer les émotions et favoriser une profonde détente.",
      "Ensemble, ces pratiques offrent un espace de sérénité où il devient possible de se recentrer et de retrouver son équilibre intérieur.",
    ],
    bienfaits: ["Gestion du stress et des angoisses", "Libération émotionnelle par le souffle", "Relaxation profonde", "Recentrage et équilibre intérieur"],
  },
  {
    slug: "lahochi",
    name: "Magnétisme — LaHoChi",
    tag: "Soin magnétique par apposition des mains",
    price: "70 €",
    duration: "1 h",
    image: "/images/lahochi.jpg",
    intro: "Le soin magnétique par excellence à Bayonne — une très haute fréquence de lumière et de vibration, par apposition des mains.",
    description: [
      "En tant que magnétiseuse, je canalise l'énergie pour aider à soulager les douleurs et apaiser les maux. Le LaHoChi permet d'accéder et d'intégrer des énergies subtiles de guérison aux fréquences plus élevées. Il restructure et équilibre les corps subtils de l'Être, particulièrement lorsqu'il y a eu un traumatisme dans le corps émotionnel.",
      "LA fait référence à la lumière, HO à cette énergie, Chi à la force vitale. Ce soin peut se faire à distance car les énergies transcendent la matière. Suite au soin, vous repartez comme neuf, nettoyé en profondeur et réharmonisé.",
      "La magie continue après la séance : pendant 21 jours, vous vous auto-soignez par l'apposition des mains — je vous montrerai tout cela lors de notre rencontre.",
    ],
    bienfaits: ["Convient aux enfants et aux animaux", "Réharmonisation profonde", "Travail sur le corps émotionnel", "Protocole d'auto-soin de 21 jours"],
  },
  {
    slug: "ventouses",
    name: "Ventouses — Cupping",
    tag: "Détoxification & décongestion",
    price: "70 €",
    duration: "1 h",
    image: "/images/ventouses.jpg",
    intro: "Une technique ancestrale pour dénouer, relâcher, drainer et détoxifier le corps par l'effet de succion, à Bayonne.",
    description: [
      "Ces manipulations stimulent l'organisme et améliorent la récupération. À la suite de l'anamnèse, nous définissons ensemble une stratégie de pose : ventouses seules, avec pression de points à l'aide d'un petit bâton, ou par glissement pour étirer un muscle, un tendon, une zone très contractée.",
      "Les ventouses peuvent être utilisées quotidiennement en cas de crise douloureuse, avant ou après un effort physique intense.",
    ],
    bienfaits: ["Soulager le stress et les troubles du sommeil", "Dénouer les blocages (torticolis, maux de dos)", "Accélérer la récupération musculaire", "Soulager entorses, tendinites, arthrose et névralgies", "Atténuer l'aspect de la cellulite"],
  },
  {
    slug: "massage-uhaina",
    name: "Massage Uhaina",
    tag: "Le massage basque — la vague",
    price: "70 €",
    duration: "1 h",
    image: "/images/uhaina.jpg",
    intro: "Un massage inspiré des éléments du Pays basque : l'air, la terre et l'eau — à Bayonne.",
    description: [
      "Inspiré du climat du Pays basque — de Saint-Jean-de-Luz à Bayonne, d'Anglet et Biarritz jusqu'à Ustaritz et Hasparren — ce massage s'articule autour de trois éléments : l'air (hegoi, le vent du sud), la terre (l'estuaire, la corniche, la montagne) et l'eau (les vagues, Belharra, les caprices de l'océan).",
      "De ce triptyque naît un massage agissant sur trois flux : énergétique, circulatoire et lymphatique. Un véritable appel à la détente, au lâcher-prise et au voyage — pour celles et ceux qui courent « à la recherche d'une vague active de sensations fortes ».",
    ],
    bienfaits: ["Lâcher-prise et voyage sensoriel", "Action énergétique, circulatoire et lymphatique", "Détente profonde"],
  },
  {
    slug: "massage-biodynamique",
    name: "Massage biodynamique",
    tag: "Les techniques du monde réunies",
    price: "110 €",
    duration: "1 h 20",
    image: "/images/biodynamique.jpg",
    intro: "Une synergie de techniques du monde — massage, aromathérapie et énergie du magnétisme, à Bayonne.",
    description: [
      "Ce massage réunit les techniques de l'Asie — Shiatsu et Tuina, à travers les méridiens énergétiques —, puis le Lomi-Lomi hawaïen, le « massage divin » aux effets de vagues qui inondent le corps d'une détente bienfaisante.",
      "Les touches ayurvédiques et la traversée des chakras nous transportent en Inde, entre marmas et points énergétiques, le tout ancré sur le terrain musculaire et les repères anatomiques du corps.",
      "Son point fort : la combinaison de toutes ces techniques dans un rythme et une énergie du cœur, qui en amplifient mille fois les effets.",
    ],
    bienfaits: ["Synergie Shiatsu, Tuina, Lomi-Lomi, Ayurvéda", "Détente globale du corps entier", "Travail énergétique des chakras", "Expérience immersive d'1h20"],
  },
  {
    slug: "massage-ventre",
    name: "Massage bien-être du ventre",
    tag: "Douceur & détox abdominale",
    price: "70 €",
    duration: "1 h",
    image: "/images/ventre.jpg",
    intro: "Un massage du ventre tout en douceur, basé sur la respiration, à Bayonne.",
    description: [
      "Chaque mouvement est accompagné par la respiration. Le travail s'effectue sur l'estomac, le diaphragme et l'intestin, en douceur et en enveloppement.",
      "Ce soin libère les émotions, procure un sentiment de bien-être et de légèreté, et relance le système d'élimination naturel — une véritable détox du ventre.",
    ],
    bienfaits: ["Confort intestinal (endométriose, douleurs menstruelles, constipation)", "Libération émotionnelle", "Détox du ventre", "Sentiment de légèreté"],
  },
];

export const FORMATIONS = [
  {
    num: "01",
    name: "Chi Nei Tsang — Épanouissement du ventre",
    duration: "5 jours",
    price: "1 100 €",
    dates: "26 — 30 octobre 2026",
    landing: "/formation-chi-nei-tsang",
    datesDetail: "Du 26 au 30 octobre 2026 · Bayonne",
    datesNote: "5 jours en présentiel, en petit groupe — 4 places ouvertes. 1 100 €.",
    audience: "Ouverte à tous, sans prérequis",
    description: "Massage profond du ventre, notre premier cerveau : relancez les cinq systèmes majeurs (vasculaire, lymphatique, nerveux, musculaire, énergétique). Théorie, anatomie de l'abdomen, techniques de manipulation, Qi Gong d'ancrage et auto-massage à transmettre à vos clients entre deux rendez-vous.",
    objectifs: [
      "Acquérir des connaissances théoriques sur le Chi Nei Tsang, son histoire et ses principes de base",
      "Comprendre l'anatomie et la physiologie de l'abdomen, ainsi que le rôle des organes internes dans la santé globale",
      "Apprendre les différentes techniques de massage et de manipulation abdominale spécifiques au Chi Nei Tsang",
      "Développer des compétences pratiques pour libérer les tensions viscérales et les émotions stagnantes",
      "Identifier les zones de tension et les déséquilibres du corps par l'observation et la palpation de l'abdomen",
      "Évaluer l'état de santé général du client afin d'adapter la séance en conséquence",
      "Comprendre les bienfaits du Chi Nei Tsang sur la digestion, le stress et l'équilibre énergétique",
      "Connaître les indications et contre-indications pour garantir la sécurité des clients",
    ],
  },
  {
    num: "02",
    name: "Réflexologie plantaire",
    duration: "5 jours",
    price: "1 100 €",
    dates: "23 — 28 novembre 2026",
    landing: "/formation-reflexologie-plantaire",
    datesDetail: "Du 23 au 28 novembre 2026 · Bayonne",
    datesNote: "5 jours en présentiel (ou en 2 week-ends : 3 jours + 2 jours), en petit groupe — 4 participants. 1 100 €.",
    audience: "Cycle de base ouvert à tous — 2e cycle pour praticiens",
    description: "Reptation, observation et palpation des pieds, correspondance des zones réflexes avec les organes et systèmes du corps, plan de soin personnalisé. Une réponse efficace aux maux du quotidien : insomnies, constipation, fatigue, douleurs. Quelques Qi Gong et méditations offerts en bonus.",
    objectifs: [
      "Acquérir des connaissances théoriques sur la réflexologie plantaire, son histoire et ses principes de base",
      "Comprendre l'anatomie et la physiologie du pied, ainsi que les zones réflexes et leur correspondance avec les organes et systèmes du corps",
      "Comprendre les bienfaits de la réflexologie plantaire sur le bien-être physique et mental, ainsi que son rôle dans la gestion du stress et des douleurs",
      "Connaître les indications et contre-indications à la pratique pour garantir la sécurité des clients",
      "Savoir intégrer la réflexologie plantaire dans un cadre professionnel : cabinet, spa ou autres environnements de bien-être",
      "Élaborer un plan de soins personnalisé pour chaque client, en tenant compte de ses besoins spécifiques et de son état de santé",
    ],
  },
  {
    num: "03",
    name: "LaHoChi de la 13e octave",
    duration: "1 jour",
    price: "120 €",
    audience: "Sans prérequis — idéal pour débuter en magnétisme",
    description: "Enseignement théorique et pratique de ce système de guérison naturelle : activation de l'énergie, positions des mains, traitement sur autrui, à distance et auto-traitement. Après l'initiation, vous pourrez transmettre l'énergie LaHoChi et créer des initiations à votre tour.",
  },
  {
    num: "04",
    name: "Kintsugi Breathwork — Vibre ta voix",
    duration: "1 jour",
    price: "350 €",
    audience: "Tout public",
    description: "Le kintsugi, art japonais de l'or sur ce qui a été cassé, mis au service de nos blessures : après avoir raconté votre histoire, nous mettons de l'or là où la douleur a été ressentie. Puis le breathwork vous fait voyager dans les méandres de l'inconscient, et la voix libère les chakras du cœur et de la gorge.",
  },
  {
    num: "05",
    name: "Massage Uhaina — le massage basque",
    duration: "2 jours",
    price: "440 €",
    audience: "Praticiens & curieux du toucher",
    description: "Un massage unique qui ne se pratique qu'au Pays basque : drainage, pétrissage, étirements, jeu de serviettes chaudes et fraîches, gestes toniques puis enveloppants comme la lèvre de la vague. Un triptyque agissant sur les flux énergétique, circulatoire et lymphatique.",
    programmeTitle: "Vous apprendrez",
    objectifs: [
      "Les manœuvres : drainage, décontraction musculaire, effleurage, pétrissage, échauffements, étirements…",
      "Sur la face dorsale : des gestes toniques, énergisants et bondissants, une température d'une chaleur d'été (jeu de serviettes chaudes), la puissance et la force du baleinier et les caprices de l'Atlantique",
      "Sur la face ventrale : des gestes lents et enveloppants telle la lèvre de la vague, de grands mouvements — le navire à trois mâts voguant à pleine voile — et la fraîcheur douce des embruns caressant la peau (jeu de serviette fraîche)",
    ],
    extra: "D'où le triptyque du massage agissant sur trois flux : énergétique, circulatoire et lymphatique. Retrouvez la force et la douceur basque, les deux saisons — l'été et l'hiver — et les vagues, pour entrer dans une détente profonde.",
  },
  {
    num: "06",
    name: "Massage biodynamique",
    duration: "2 jours",
    price: "440 €",
    audience: "Ouverte à tous — paiement en 2 fois possible",
    description: "Une invitation au voyage physique, spirituel et psychologique : Shiatsu, Tuina, Lomi-Lomi, touches ayurvédiques et énergie du magnétisme. Un protocole de soin énergétique, décontractant et dynamisant qui décharge les mémoires émotionnelles et vous démarquera des autres cabinets.",
    extra: "Ce procédé de massage biodynamique réveille les processus naturels d'auto-régénérescence en déchargeant les mémoires émotionnelles encombrantes ainsi que les toxines. Cette méthode de soin apporte un lâcher-prise physique et mental de manière impressionnante : elle permet de retrouver une grande confiance, l'estime de soi, un grand sentiment de paix, de joie de vivre, d'amour — et surtout d'harmoniser les charges émotionnelles qui bloquent notre énergie. Cette formation vous permettra d'offrir à vos clientes et clients un massage complet du corps, une nouveauté jamais vue ailleurs, un réel lâcher-prise.",
  },
  {
    num: "07",
    name: "Drainage lymphatique (méthode Vodder)",
    duration: "2 jours",
    price: "440 €",
    audience: "Praticiens du bien-être",
    description: "Anatomie et physiologie du système lymphatique, manœuvres et protocoles à visée esthétique, de confort ou sportive. À l'issue de la formation, vous pratiquez efficacement le drainage lymphatique manuel dans le respect des normes de sécurité et d'hygiène.",
    extra: "Le drainage diminue l'œdème post-cancer et atténue les douleurs, améliore et soulage les varices, avec de nets résultats chez les personnes atteintes de fibromyalgie, spondylarthrite ou polyarthrite — une amélioration réelle de leur état de santé et de leur qualité de vie.",
    objectifs: [
      "Apprendre une technique spécifique et performante, inspirée des travaux d'Emil Vodder, qui a fait ses preuves",
      "Acquérir des connaissances sur l'anatomie et la physiologie du système lymphatique, ainsi que sur les indications et contre-indications du drainage lymphatique",
      "Maîtriser les différentes manœuvres et protocoles à appliquer selon les besoins des patients",
      "Devenir un praticien compétent, capable d'apporter un bien-être à ses clients tout en respectant les normes de sécurité et d'hygiène",
    ],
  },
  {
    num: "08",
    name: "Massage bien-être du ventre",
    duration: "1 jour",
    price: "400 €",
    audience: "Sans prérequis — paiement en 2 fois possible",
    description: "Une technique simple et efficace, réalisable sur tous, même les enfants. Elle répond aux maux liés à l'endométriose, la constipation, les tensions musculaires et nerveuses, et contribue à la libération des émotions et à la gestion du stress.",
  },
  {
    num: "09",
    name: "Massage crânien (Shiromassage)",
    duration: "1 jour",
    price: "250 €",
    audience: "Sans prérequis",
    description: "Issu de la médecine indienne : un protocole complet incluant nuque, épaules, crâne et oreilles (pétrissage, lissage, digito-pression) pour soulager maux de tête, cervicalgies, stress et nervosité — et offrir un état de relaxation profonde.",
    extra: "Durant cette journée, vous découvrirez les gestes essentiels, la qualité de présence dans le toucher et la fluidité d'un protocole de 30 minutes que vous pourrez intégrer facilement dans votre pratique professionnelle ou personnelle. Cette formation est ouverte à toutes les personnes attirées par l'art du toucher, aux praticiens du bien-être et aux thérapeutes souhaitant enrichir leurs outils. Vous repartirez avec un protocole clair, la confiance pour pratiquer et l'expérience d'un toucher profondément apaisant.",
  },
  {
    num: "10",
    name: "Shinzu — Hands of the Heart",
    duration: "3 heures",
    price: "99 €",
    audience: "Sans prérequis",
    description: "Une autre approche de la réflexologie palmaire : massage et auto-massage des mains combinés à la puissance des mudras et à une huile essentielle joyeuse. Détox, boost immunitaire, sommeil retrouvé — un monde entier au bout de vos doigts.",
  },
];

export const TEMOIGNAGES = [
  {
    name: "Nicolas",
    soin: "Avis Google · ★★★★★",
    quote: "Je ne sais pas par quoi commencer… De prime abord, je suis plutôt contre ce genre de médecine, et pourtant, être bluffé est un euphémisme. Les maux étaient plus profonds que les mots. On fait le solide, mais quand le corps lâche, il faut accepter de faire ressortir ce qui nous empêche d'être soi-même. Julie a cette capacité : elle a su extérioriser des choses que je n'imaginais même pas, ou que je ne voulais pas voir. Ce soin m'a redonné quelque chose que j'avais perdu : mon vrai moi. Tu as des mains de génie et un don incroyable. Merci infiniment.",
  },
  {
    name: "Andréa",
    soin: "Avis Google · ★★★★★",
    quote: "Je suis allée voir Julie deux jours après une entorse, assez sceptique au départ, mais vraiment contente d'avoir essayé ! J'ai ressenti un vrai soulagement au niveau de l'inflammation. J'ai aussi beaucoup apprécié sa douceur, son écoute et sa bienveillance. Une très belle découverte que je recommande avec plaisir.",
  },
  {
    name: "Sabine",
    soin: "Avis Google · ★★★★★",
    quote: "Une expérience bien au-delà de mes attentes. Julie est solaire, profondément bienveillante et incroyablement réconfortante. Son toucher est d'une grande justesse, mais c'est surtout sa présence et son écoute qui m'ont touchée. Je suis sortie émue, apaisée et profondément reconnectée à moi-même. Une praticienne exceptionnelle, qui exerce avec cœur et humanité. Je recommande les yeux fermés.",
  },
  {
    name: "Sophie",
    soin: "Constellation & Chi Nei Tsang · Avis Google · ★★★★★",
    quote: "Je viens de Nice et je m'offre une séance à chaque fois que je viens sur la côte basque : c'est incontournable ! Constellation familiale, Chi Nei Tsang, libération des émotions… tellement de bienfaits. Ce que j'aime avec Julie ? L'alliance du savoir-être et du savoir-faire. Elle est pleinement ce qu'elle fait.",
  },
];

export const TEMOIGNAGES_DEFILANT = [
  { name: "Sandrine", quote: "Je recommande vivement Julie qui me réconcilie avec mon corps et me permet de lâcher mes émotions, en toute bienveillance." },
  { name: "Avis Google", quote: "Julie crée une atmosphère de confiance dès le premier contact." },
  { name: "Avis Google", quote: "Une présence rare et bienveillante, qui apaise et éclaire à la fois." },
  { name: "Avis Google", quote: "Une écoute attentive, sans jugement : on se sent vraiment entendu et respecté." },
  { name: "Avis Google", quote: "Au-delà du corps, un vrai lâcher-prise émotionnel." },
  { name: "Avis Google", quote: "Une détente profonde, physique et mentale, qui dure bien après la séance." },
  { name: "Avis Google", quote: "Un professionnalisme remarquable, dans un lieu cocooning." },
  { name: "Camille", quote: "Une semaine hors du temps dans les dunes. Merci Julie pour cette guidance en douceur." },
];

export const CABINETS = [
  { city: "Bayonne", address: "10 rue Gosse", zip: "64100 Bayonne" },
  { city: "Bellignat", address: "14 rue Castellion Prolongée", zip: "01100 Bellignat" },
];

export const QUI_SUIS_JE = [
  "En tant que thérapeute, ma vocation est d'accompagner chaque individu sur son chemin vers le bien-être, l'épanouissement et la liberté intérieure. Mon approche est holistique : elle intègre une variété de techniques qui favorisent le rééquilibre énergétique et émotionnel, tout en respectant l'unicité de chaque personne.",
  "Praticienne en médecine chinoise, spécialisée dans le Chi Nei Tsang, je m'intéresse à l'énergie vitale qui circule dans le corps. Cette approche me permet de travailler sur les organes internes, d'éliminer les blocages émotionnels et de favoriser une meilleure circulation de l'énergie.",
  "Je pratique également la sophrologie et le breathwork, deux méthodes puissantes qui reconnectent le corps et l'esprit. Ensemble, ces pratiques offrent un espace de sérénité où il est possible de se recentrer et de retrouver son équilibre intérieur.",
  "Ostéothérapeute, je m'efforce de rétablir l'harmonie dans le corps par des techniques manuelles douces. Je crois fermement que le corps a une capacité naturelle à se guérir — mon rôle est de l'accompagner dans ce processus.",
  "Je me considère comme une magicienne bienveillante, œuvrant avec douceur et fermeté. Je suis là pour soutenir, écouter et accompagner chacun dans son parcours, en créant un espace de confiance où il est possible d'exprimer ses émotions et ses besoins.",
];
